"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useAutoclose;
var _react = require("react");
/**
 * Use auto close logic
 * logic for auto closing stuff (modal).
 * @param {UseAutocloseProps} props
 */
function useAutoclose({
  onClose,
  autoClose,
  open,
  timeoutMs
}) {
  (0, _react.useEffect)(() => {
    if (!autoClose || !open) {
      return undefined;
    }
    const handle = setTimeout(onClose, timeoutMs);
    return () => {
      clearTimeout(handle);
    };
  }, [onClose, autoClose, open, timeoutMs]);
}
